import * as R from 'ramda'

import { setNormalizedScore } from 'utils/score'
import { SKILL_RANGE } from './model'

export const mapInternalStateToPayload = state => {
  const { evaluators } = state

  return R.reduce(
    (acc, { comment, key, score }) => ({
      ...acc,
      [key]: { comment, score: setNormalizedScore(SKILL_RANGE)(score) },
    }),
    {},
    evaluators,
  )
}
